var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntelligentDashboards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32.455 32.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8162",
    "data-name": "Group 8162",
    transform: "translate(-2 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24881",
    "data-name": "Path 24881",
    d: "M22.37,4.617a1.184,1.184,0,1,0,0-2.367H17.564c-2.9,0-5.17,0-6.972.2a9.189,9.189,0,0,0-4.6,1.538A9.074,9.074,0,0,0,3.983,5.99a9.189,9.189,0,0,0-1.538,4.6c-.2,1.8-.2,4.074-.2,6.972v.143c0,2.9,0,5.17.2,6.972a9.19,9.19,0,0,0,1.538,4.6A9.073,9.073,0,0,0,5.99,31.289a9.189,9.189,0,0,0,4.6,1.538c1.8.2,4.074.2,6.972.2h.143c2.9,0,5.17,0,6.972-.2a9.189,9.189,0,0,0,4.6-1.538,9.072,9.072,0,0,0,2.007-2.007,9.189,9.189,0,0,0,1.538-4.6c.2-1.8.2-4.074.2-6.972V12.9a1.184,1.184,0,1,0-2.367,0v4.734c0,2.985,0,5.129-.181,6.789a6.888,6.888,0,0,1-1.1,3.466,6.7,6.7,0,0,1-1.484,1.484,6.888,6.888,0,0,1-3.466,1.1c-1.66.18-3.8.181-6.789.181s-5.129,0-6.789-.181a6.888,6.888,0,0,1-3.466-1.1A6.705,6.705,0,0,1,5.9,27.89a6.888,6.888,0,0,1-1.1-3.466c-.18-1.66-.181-3.8-.181-6.789s0-5.129.181-6.789A6.888,6.888,0,0,1,5.9,7.382,6.707,6.707,0,0,1,7.382,5.9a6.888,6.888,0,0,1,3.466-1.1c1.66-.18,3.8-.181,6.789-.181Z",
    transform: "translate(0 0.434)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24882",
    "data-name": "Path 24882",
    d: "M6.371,18.072A1.184,1.184,0,1,0,8.5,19.115l2.3-4.7a1.88,1.88,0,0,1,3.428.116,4.247,4.247,0,0,0,7.744.262l2.3-4.7a1.184,1.184,0,0,0-2.125-1.042l-2.3,4.7a1.88,1.88,0,0,1-3.428-.116,4.247,4.247,0,0,0-7.744-.262Z",
    transform: "translate(2.312 3.984)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24883",
    "data-name": "Path 24883",
    d: "M17.5,5.445A3.945,3.945,0,1,0,21.445,1.5,3.945,3.945,0,0,0,17.5,5.445Zm2.367,0a1.578,1.578,0,1,0,1.578-1.578A1.578,1.578,0,0,0,19.867,5.445Z",
    transform: "translate(8.815)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelligentDashboards);
export default __webpack_public_path__ + "static/media/IntelligentDashboards.af636ea5cd96e65d483cad569b0ee9d8.svg";
export { ForwardRef as ReactComponent };